<div
    class="chatbot-launcher-container"
    [style.--chatbot-bottom-offset]="bannerHeight + 'px'">
    <div class="tooltip-container" *ngIf="showTooltip" [@tooltipAppear]>
        Try out CLARK AI!
    </div>
    <button
        class="chatbot-icon-button"
        (click)="openChatbot()"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
        aria-label="Open CLARK AI chatbot">
        <i class="fas fa-comment-alt chatbot-icon"></i>
    </button>
</div>
